import React, { useState } from "react";
import classes from "./Login.module.css";
import RccgLogo from '../../Assets/rotating-logo.png';
import CalculatorIcon from '../../Assets/cal.png';
import GrowthIcon from '../../Assets/growth.png';
import TeamIcon from '../../Assets/team.png';
import RotatingLogo from '../../Assets/rotating-logo.png';
import { useNavigate } from "react-router-dom";
import eye from "../../Assets/eye.svg";
import eyesoff from "../../Assets/eyesoff.svg";
import { Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { BASE_URL } from "../../Components/Styles/API/API";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/login`,
                {
                    email: email,
                    password: password
                }
            );
            
            const result = response.data?.data?.user?.name;
            const locals = response.data?.data?.currency;
            const resultID = response.data?.data?.user?.id;
            const provinceID = response.data?.data?.user?.province?.id;
            const continentID = response.data?.data?.user?.continent?.id || response.data?.data?.user?.continent_id;
            const regionID = response.data?.data?.user?.region?.id;
            const addresses = response.data?.data?.user?.company?.address;
            const phones = response.data?.data?.user?.company?.phone_number;
            const phone = response.data?.data?.user?.phone_number;
            const emails = response.data?.data?.user?.company?.email;
            const resultx = response.data?.data?.user?.email;
            const results = response.data?.data?.token;
            const permit = response.data?.data?.module;
            const allPermit = response.data?.data?.access;
            const continent = response.data?.data?.user?.continent?.description;
            const region = response.data?.data?.user?.region?.description;
            const province = response.data?.data?.user?.province?.description;
            const currentMonth = response.data?.data?.user?.province?.current_month;
            // console.log(response);
            const isAdmin = response.data?.data?.user?.type_name;
            const userType = response.data?.data?.user?.type;
            console.log(userType);
            const companyName = response.data?.data?.user?.parish_name;
            const companyId = response.data?.data?.user?.company?.id;
            localStorage.setItem('permissions', JSON.stringify(permit));
            localStorage.setItem('allPermissions', allPermit);
            localStorage.setItem('Currency', locals);
            localStorage.setItem('admin', isAdmin);
            localStorage.setItem('companyName', companyName);
            localStorage.setItem('tobi', result);
            localStorage.setItem('tobiID', resultID);
            localStorage.setItem('userToken', results);
            localStorage.setItem('userEmail', resultx);
            localStorage.setItem('userType', userType);
            localStorage.setItem('companyEmail', emails);
            localStorage.setItem('companyPhone', phones);
            localStorage.setItem('phone', phone);
            localStorage.setItem('companyAddress', addresses);
            localStorage.setItem('companyId', companyId);
            localStorage.setItem('permits', permit);
            localStorage.setItem('continent', continent);
            localStorage.setItem('region', region);
            localStorage.setItem('province', province);
            localStorage.setItem('provinceID', provinceID);
            localStorage.setItem('continentID', continentID);
            localStorage.setItem('regionID', regionID);
            localStorage.setItem('currentMonth', currentMonth);

                navigate('/otp_secure');

        } catch (error) {
            let errorMessage = error.response?.data?.message || 'An error occurred';
            if (error.message === 'Network Error') {
                errorMessage = 'Connection error. Please check your internet connection.';
            }
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: JSON.stringify(error.response.data.message),
              });
        } 
        finally {
            setLoading(false);
        }
    }

  return (
    <div className={classes.loginPage}>
      {/* LEFT SIDE (Hides on mobile) */}
      <div className={classes.leftSide}>
        <img src={RccgLogo} alt="Suite" className={classes.rlogo} />
        <h1 className={classes.topHeader}>Smart Accounting for Church Management</h1>
        <p className={classes.subHeader}>
          Streamline your finances with AI-powered tools designed
          specifically for Church Management
        </p>

        <div className={classes.featureBox}>
          <img src={CalculatorIcon} alt="Calculator" />
          <div>
            <p className={classes.cro_pt}>Complete Accounting Suite</p>
            <p className={classes.mind}>Everything you need to manage your finances</p>
          </div>
        </div>

        <div className={classes.featureBox}>
          <img src={GrowthIcon} alt="Growth" />
          <div>
            <p className={classes.cro_pt}>Growth Analytics</p>
            <p className={classes.mind}>Track your business growth with detailed reports</p>
          </div>
        </div>

        <div className={classes.featureBox}>
          <img src={TeamIcon} alt="Team" />
          <div>
            <p className={classes.cro_pt}>Team Collaboration</p>
            <p className={classes.mind}>Work together with your team seamlessly</p>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE LOGIN BOX */}
      <div className={classes.loginBox}>
        <h1 className={classes.signTxt}>Sign In</h1>

        <div className={classes.formGroup}>
          <label>Email Address</label>
          <input
            type="email"
            placeholder="Enter your email"
            className={classes.print}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className={classes.formGroup}>
          <label>Password</label>
          <div className={classes.portal}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              className={classes.print}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <img
              src={showPassword ? eyesoff : eye}
              alt="Toggle visibility"
              className={classes.eye}
              onClick={() => setShowPassword((prev) => !prev)}
            />
          </div>
        </div>

        <div className={classes.options}>
         
  <Form.Check 
    type="switch"
    id="remember-switch"
    label="Remember Me"
    className={classes.rememberMe}
  />

          <span onClick={() => navigate('/forgot_password')} className={classes.forgotPassword}>Forgot Password?</span>
        </div>
   <Button onClick={handleLogin} disabled={!email || !password} variant="primary" className={classes.signInBtn}>Sign In</Button>
      </div>
   {loading && (
  <div className={classes.overlay}>
    <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
  </div>
)}
    </div>
  );
}
